import React, {Component, PropTypes} from 'react'
import {Select} from '../select'
import {months} from '../time'
import {ValidateInput} from '../validate_input'
import _ from 'lodash'

// to use this component, you must manually include the stripe.js script BEFORE bundle.js

export class PaymentForm extends Component {

  static propTypes = {
    onCharge: PropTypes.func,
    tableHost: PropTypes.string,
    stripeKey: PropTypes.string,
    profileId: PropTypes.string.isRequired
  }

  static defaultProps = {
    onCharge: () => {},
    stripeKey: 'pk_test_PJauI5nh8jeazkI9KmalheEp',
    // stripeKey: 'pk_live_zigMJiz3l43wgIlVmTJlDQXf',
    tableHost: ''
  }

  state = {
    error: null
  }

  componentDidMount () {
    /*
    if (!window.Stripe) {
      const stripejsTag = document.createElement('script')
      stripejsTag.setAttribute('src', 'https://js.stripe.com/v2/')
      document.head.appendChild(stripejsTag)
    }
    */
    if (window.Stripe) {
      window.Stripe.setPublishableKey(this.props.stripeKey)
    }
  }

  submit (e) {
    e.preventDefault()
    if (window.Stripe) {
      const {profileId, onCharge, tableHost} = this.props
      const form = this._form
      window.Stripe.card.createToken(form, async (status, token) => {
        const res = await window.fetch(`${tableHost}/payments/api/charges/${profileId}`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            authentication: window.localStorage.getItem('ut'),
            'content-type': 'application/json'
          },
          body: JSON.stringify({token: token.id, amount: 1000, capture: false})
        })
        if (res.status >= 400) {
          this.setState({error: await res.text()})
        }
        onCharge(await res.json(), token)
      })
    }
  }

  render () {
    const monthOptions = _.map(months, (val, index) => {
      return { content: (index < 10 ? '0'  : '') + index, value: index }
    })

    let year = (new Date()).getFullYear()
    const yearOptions = _.map((new Array(10)), () => {
      return { content: year, value: year++ }
    })

    return <div>
      {this.state.error && <span>{this.state.error}</span>}
      <form
        className='payment__form'
        ref={r => { this._form = r }}
        onSubmit={::this.submit}
      >
        <div className='row payment__row'>
          <div>
            <label className='form__label'>Card Number</label>
            <ValidateInput
              className='form__input'
              type='text'
              pattern='[0-9]{13,16}'
              rejectExpression={/[^\d\s]/g}
              characterLimit={16}
              size={16}
              data-stripe='number'
            />
          </div>
          <div>
            <label className='form__label'>CVC</label>
            <ValidateInput
              className='form__input'
              characterLimit={3}
              rejectExpression={/[^\d\s]/g}
              type='text'
              size={3}
              data-stripe='cvc'
            />
          </div>
        </div>
        <div className='payment__row'>
          <label className='form__label'>Valid Through</label>
          <div className='row'>
            <Select
              options={monthOptions}
              defaultValue={0}
              className='payment__select'
              data-stripe='exp_month'
            />
            <Select
              options={yearOptions}
              defaultValue={(new Date()).getFullYear()}
              className='payment__select'
              data-stripe='exp_year'
            />
          </div>
        </div>
        <button className='button--green' onClick={::this.submit}>Add Card</button>
      </form>
    </div>
  }
}
